/**
 * The store's half of the landing reporter.
 *
 * Everything a landing report says is defined once, in
 * packages/utils/src/landingBeacon.ts, so that the store and the portal describe
 * the same journey in the same words and the two records can be read together.
 * Only what is genuinely the store's own lives here.
 */
export {
    ELandingBeaconStage,
    LANDING_BEACON_BOOTED_EVENT,
    LANDING_BEACON_ELEMENT_ID,
    LANDING_BEACON_FIRST_REPORT,
    LANDING_BEACON_MILESTONES_MS,
    LANDING_BEACON_PARSED_FLAG,
    LANDING_BEACON_ROUTE,
    LANDING_BEACON_SRC,
    LANDING_BEACON_STAGES,
    announceLandingBoot,
    isLandingKey,
} from '@web-store-platforms/utils';

/**
 * The global the app sets once it is running, read by the reporter so a report
 * can say whether our code ever executed. Without it every silent landing looks
 * the same, and a page that never booted is indistinguishable from one that
 * booted and then failed — which need opposite fixes.
 *
 * Named separately from the portal's because the reporter is served by both and
 * a document has to say which app it belongs to.
 */
export const STORE_BOOTED_FLAG = '__acStoreBooted';
